import _asyncToGenerator from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/regenerator/index.js";
import axios from '@vtblife/axios';
var GeoApiService = /*#__PURE__*/function () {
  function GeoApiService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'root';
    _classCallCheck(this, GeoApiService);
    this.transport = axios.create({
      baseURL: "/api/".concat(name, "-bff/")
    });
  }
  _createClass(GeoApiService, [{
    key: "getGeoSuggest",
    value: function () {
      var _getGeoSuggest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(text, cancelToken) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.transport.get('/api/get-geo-suggest', {
                params: {
                  text: text
                },
                cancelToken: cancelToken
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getGeoSuggest(_x, _x2) {
        return _getGeoSuggest.apply(this, arguments);
      }
      return getGeoSuggest;
    }()
  }, {
    key: "getGeoObjectByIdV2",
    value: function () {
      var _getGeoObjectByIdV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(regionId, cancelToken) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", this.transport.get('/api/get-geo-object-by-id-v2', {
                params: {
                  regionId: regionId
                },
                cancelToken: cancelToken
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getGeoObjectByIdV2(_x3, _x4) {
        return _getGeoObjectByIdV.apply(this, arguments);
      }
      return getGeoObjectByIdV2;
    }()
  }]);
  return GeoApiService;
}();
var geoApiService = new GeoApiService();
export { geoApiService };